export const COLORS = {
  purple: '#FF11E5',
  lightOrange: '#edba53',
  yellow: '#f4e55e',
  black: '#000000',
  white: '#ffffff',
};
